import {toBoolean, toString} from "../helpers/helpers";

export class K2GroupModel {
  areaName: string;
  areaId: string;
  groupName: string;
  groupId: string;
  areaDisabled: boolean;
  groupDisabled: boolean;

  addedToProject: boolean;

  doUsageCollection: boolean;
  doTonerMonitoring: boolean;
  doTonerAutoOrder: boolean;
  doInkMonitoring: boolean;
  doInkAutoOrder: boolean;
  doPrintHeadMonitoring: boolean;
  doPrintHeadAutoOrder: boolean;
  doMaintenanceMonitoring: boolean;
  doMaintenanceAutoOrder: boolean;
  doFastenerMonitoring: boolean;
  doFastenerAutoOrder: boolean;

  hasVerificationContactUploader: boolean;
  hasExceptionContactUploader: boolean;
  hasConsumableAddressUploader: boolean;
  hasServiceAddressUploader: boolean;
  disableEditReasons: string;

  get canonicalGroupName() {
    return this.groupName.toLowerCase();
  }

  get canonicalAreaName() {
    return this.areaName.toLowerCase();
  }

  get key() {
    return JSON.stringify([this.canonicalAreaName, this.canonicalGroupName]);
  }

  static converter = (json?: any) => new K2GroupModel(json);

  constructor(json?: any) {
    json = json || {};

    this.areaName = toString(json.areaName) || "";
    this.groupName = toString(json.groupName) || "";
    this.areaId = toString(json.areaId) || "";
    this.groupId = toString(json.groupId) || "";

    this.doUsageCollection = toBoolean(json.doUsageCollection, true);
    this.doTonerMonitoring = toBoolean(json.doTonerMonitoring);
    this.doTonerAutoOrder = toBoolean(json.doTonerAutoOrder);
    this.doInkMonitoring = toBoolean(json.doInkMonitoring);
    this.doInkAutoOrder = toBoolean(json.doInkAutoOrder);
    this.doPrintHeadMonitoring = toBoolean(json.doPrintHeadMonitoring);
    this.doPrintHeadAutoOrder = toBoolean(json.doPrintHeadAutoOrder);
    this.doMaintenanceMonitoring = toBoolean(json.doMaintenanceMonitoring);
    this.doMaintenanceAutoOrder = toBoolean(json.doMaintenanceAutoOrder);
    this.doFastenerMonitoring = toBoolean(json.doFastenerMonitoring);
    this.doFastenerAutoOrder = toBoolean(json.doFastenerAutoOrder);

    this.areaDisabled = toBoolean(json.areaDisabled);
    this.groupDisabled = toBoolean(json.groupDisabled);
    this.addedToProject = toBoolean(json.addedToProject);

    this.hasVerificationContactUploader = toBoolean(json.hasVerificationContactUploader, true);
    this.hasExceptionContactUploader = toBoolean(json.hasExceptionContactUploader, true);
    this.hasConsumableAddressUploader = toBoolean(json.hasConsumableAddressUploader, true);
    this.hasServiceAddressUploader = toBoolean(json.hasServiceAddressUploader, true);
    this.disableEditReasons = toString(json.disableEditReasons) || "";
  }
}
